import rawMessages from '../../mobile_languages/web/en.json';


const baseMessages = Object.keys(rawMessages).reduce((acc, key) => {
    acc[key] = {
        id: key,
        defaultMessage: rawMessages[key],
    };
    return acc;
}, {});

const messages = new Proxy(baseMessages, {
    get(target, key) {
        if (key in target) return target[key];
        return { id: key, defaultMessage: '[Key not found]' };
    },
});

export default messages;